// istanbul ignore file
// This file ONLY re-exports offer-redux selectors. If we add new logic, it belongs in a different module
import { selectors } from '@makemydeal/dr-offer-redux';
import type { GenericObject } from '@makemydeal/dr-platform-types';

export const getDealXgId = (state: GenericObject): string => selectors.getDealXgId(state) as string;

export const getDealXgVersion = (state: GenericObject): string => selectors.getDealXgVersion(state) as string;

export const getIsDealXgRecordMissed = (state: GenericObject): boolean => selectors.getIsDealXgRecordMissed(state);

export const {
    capitalizeTaxItems,
    filterCountedLenderFees,
    findAllIncentiveTotalFromOffer,
    getFsDealRefId,
    getUdCorrelationId,
    getAcqFeeOverride,
    getAcqFeeUpFrontOverride,
    getAcquisitionFeeFromTerm,
    isAcqFeeStillDealerEntered,
    getActionForPayment,
    getAddsToCapCostTotal,
    getAdjustedCapCost,
    getAdjustedResidualPercent,
    getAdjustedResidualValue,
    getAdvanceFlatTax,
    getAdvanceSalesTax,
    getAllIncentiveTotal,
    getAllIncentiveTotalByOfferType,
    getAllTaxesItemized,
    getAllTaxesItemizedWithoutFlat,
    getAnnualMiles,
    getAnnualMilesByTerm,
    getAnnualMilesOptions,
    getInputAnnualMiles,
    getDealXgAutoSelectProgramSavedAt,
    getAppliedConditionalIncentives,
    getAppliedConditionalIncentivesAmount,
    getAppliedIncentives,
    getAppliedIncentivesForNonDealerCash,
    getAppliedIncentivesMappedForAIO,
    getAppliedIncentivesTotalForDealerCash,
    getAppliedIncentivesTotalForNonDealerCash,
    getSelectedIncentiveIdsFromPenciledInputs,
    getSelectedConditionalIdsFromPenciledInputs,
    getSelectedNonConditionalIdsFromPenciledInputs,
    getAppliedIncentiveIdsForSelectedTerm,
    getAppliedNonconditionalIncentivesAmount,
    getApr,
    getAutoTermId,
    getAvailableFinanceTermsOptions,
    getAvailableLeaseTermsOptions,
    getBalloonType,
    isBalloonDeal,
    getBaseMonthlyPayment,
    getBaseMonthlyPaymentTotal,
    getBaseResidualDollar,
    getBalloonAmount,
    getBalloonTermByType,
    getBalloonExpiration,
    getBaseResidualPercent,
    getProgramResidualPercent,
    getProgramResidual,
    getBuyRate,
    getBuyRateOverride,
    getBuyRateByOfferType,
    getBuyRateOverrideByOfferTypeAndTerm,
    getTypedBuyRateByOfferTypeAndTerm,
    getTypedBuyRateOverrideByOfferTypeAndTerm,
    getCapCostReduction,
    getCapCostReductionOverride,
    getCapCostReductionTax,
    getCapCostReductionTaxItem,
    getCapCostTotal,
    getCapitalizedAccessories,
    getCapitalizedDealerFees,
    getCapitalizedFeesByOfferType,
    getCapitalizedGovFees,
    getCapitalizedLenderFees,
    getCapitalizedProtectionProducts,
    getCapitalizedTaxes,
    getCapitalizedTaxTotal,
    getCapitalizeFirstPayment,
    getCapReductionRebate,
    getCapReductionTaxCapitalizedIndicator,
    getCapReductionTradeIn,
    getCashApplyMethod,
    getCashConditionalsIncentives,
    getCashNonConditionalsIncentives,
    getCashIncentivesContext,
    getCashDueFromCustomer,
    getCashOfferRoundedUp,
    getCashOffsetAmountAddedToPrice,
    getCashOffsetPriorLoanBalance,
    getCashOption,
    getCashTotalAmountDueAfterCredits,
    getCmdMessageToSalesperson,
    getCmdMessageToShopper,
    getCoBuyerCommonConsumerId,
    getCoBuyerFullName,
    getCoBuyerInfo,
    getCommonOrgId,
    getCreditAppCoApplicantEmail,
    getCreditAppId,
    getCreditDecisionEnabled,
    getCreditDecisionLender,
    getCreditDecisionLenderName,
    getCreditDecisionStatus,
    getCreditScoreSource,
    getCreditTierById,
    getDealerDefaultCreditTier,
    getCreditTiers,
    getCalculationEndpointByOfferType,
    getCalculationEndpointsState,
    getDealerForcedUpq,
    getDealerOptedOutOfAutoSelectProgram,
    getCurrentFlexBuyPayments,
    getCurrentOfferType,
    getCustomRateGroup,
    getCustomerState,
    getDaysToFirstPayment,
    getDaysToFirstPaymentBySelectedTerm,
    getDealDeposit,
    getDealerAcquisitionFeeAmountByOfferType,
    getDealerAcquisitionFeeFromTerm,
    getDealerAcquisitionFeeUpfrontByOfferType,
    getDealerFees,
    getDealerFeesTotalFromTerm,
    getDealerLenderFeesFromTerm,
    getDealRefId,
    getDealRefIdFS,
    getDeviceType,
    getDiaAccessories,
    getDiaDealerFees,
    getDiaDueAtSigning,
    getDiaGovFees,
    getDiaLenderFees,
    getDiaProtectionProducts,
    getDiaTaxes,
    getDiscount,
    getDmvFeesFromTerm,
    getDownPayment,
    getDownPaymentByOfferType,
    getDueAtSigning,
    getDueAtSigningByTerm,
    getDueAtSigningFromDueInAdvance,
    getDueAtSigningPaidByFromDueInAdvance,
    getEquityAllocationMethod,
    getExcessAmount,
    getExcessMileageCharge,
    getExcessMileRate,
    getFeesOverride,
    getFirstMonthPayment,
    getFirstPaymentAmount,
    getFirstPaymentCapitalized,
    getFirstPaymentTerm,
    getFlexBuyPayment,
    getFlexBuyPaymentGridCashDowns,
    getFlexBuyPaymentGridCashDownsList,
    getFlexBuyPaymentGridData,
    getFlexBuyPaymentGridPercents,
    getFlexBuyPaymentGridPercentsList,
    getFlexBuyPaymentGridSellRates,
    getFlexBuyPaymentGridTerms,
    getFlexBuyPaymentGridTermsList,
    getFlexBuyPaymentGridToggle,
    getFordFlexBuyData,
    getGlobalCustomerId,
    getGovernmentFees,
    getGovernmentUpfrontFeeTotal,
    getIncentivesTotalOverride,
    getIncentivesTotalOverrideByOfferType,
    getInceptionRate,
    getInitialDownPaymentListForGrid,
    getInitialMileageCharge,
    getInitialMilesCharged,
    getInitialPaymentDiscount,
    getInitialTermsMonthsListForGrid,
    getIsError,
    getIsTargetOutOfPocket,
    getIsProgramQuotes,
    getIsUserProgramQuotes,
    getItemizedLenderFees,
    getLeaseMileage,
    getResidualType,
    getLeaseOfferPrice,
    getLenderLegalName,
    getLenderProgramEndDate,
    getLenderProgramId,
    getLastPaymentMissingUPQFields,
    getManualCreditScore,
    getManualIncentiveRebatesByOfferType,
    getManualIncentives,
    areProgramStandardsFetched,
    getManualTotalTax,
    getManualTotalTaxEdited,
    getMaxResidualizedMsrp,
    getMaxResidualizedMsrpApplied,
    getMessage,
    getMessagesFromCurrentTerm,
    getMileageChargeOverride,
    getMoneyFactor,
    getMonthlyPaymentByOfferType,
    getMonthlyPaymentRoundedByOfferType,
    getMonthlyRentCharged,
    getMonthlyUseTax,
    getMonthlyPaymentTaxItems,
    getNetCashDown,
    getNetCashPayout,
    getLeaseRecordsByTermAndDownPayment,
    getNonConditionalsByOfferType,
    getNonConditionalTotal,
    getOffer,
    getOfferCreationDate,
    getOfferCreationDateString,
    getOfferDealerDiscounts,
    getOfferDealerDiscountsTotalAmount,
    getOfferDealerSource,
    getOfferDetails,
    getOfferFlatTaxItem,
    getOfferId,
    getOfferInitialPaymentDiscount,
    getOfferPrice,
    getOfferPriceByOfferType,
    getOfferPrimaryTaxItem,
    getOfferSource,
    getOfferSummary,
    getOfferTerm,
    getOutsideLienholder,
    getPaidAtSigning,
    getPaymentFrequency,
    getPaymentGridABPencilPrinting,
    getPaymentGridCashDown,
    getPaymentGridCellPricedAt,
    getPaymentGridColumnSources,
    getPaymentGridColumnView,
    getOwnColumnOverride,
    getPaymentGridCellRecord,
    getPaymentGridColumnOverrides,
    getPaymentGridOverriddenInputs,
    getPaymentGridOverriddenInputIndices,
    getPaymentGridCarriedOverride,
    getPaymentGridCarriedOverrides,
    getPaymentGridDealColumnIndex,
    getPaymentGridDecidedColumns,
    getPaymentGridErroredColumns,
    getResolvedPaymentGridSelectedColumnIndex,
    getResolvedPaymentGridSelectedRowIndex,
    getPaymentGridColumnIndicesAwaitingPair,
    getPaymentGridColumnsPairRejected,
    getPaymentGridColumnIndicesPairRejected,
    getPaymentGridPendingSellRates,
    getPaymentGridErrorState,
    getPaymentGridItems,
    getPaymentGridAdjustedResiduals,
    getPaymentGridResiduals,
    getPaymentGridSellRates,
    getPaymentGridTerms,
    getPaymentGridTermsList,
    getPaymentGridToggle,
    getPaymentGridUserSuppliedSellRateTerms,
    getPaymentGridProgramBackedTerms,
    getPaymentGridUserSuppliedResidualTerms,
    getPaymentProgramInfoByTerm,
    getDealPaymentProgram,
    getPaymentProducts,
    getPenciledInputs,
    getPreviousFinanceInputWithoutFlexBuy,
    getPrimaryTaxBreakdown,
    getPriorLoanBalance,
    getRateType,
    getRateTypeOverrideByOfferType,
    getResidualInfoOverride,
    isLeaseResidualMissing,
    getRetailPriceOverride,
    getRetailPriceOverrideByOfferType,
    getRetroMiles,
    getSavedOfferType,
    getSavedSpecialPaymentFormula,
    getSecondPaymentAmount,
    getSecondPaymentDueDate,
    getSecondPaymentTerm,
    getSecurityDepositOverride,
    getMaxResidualizedMsrpOverrideByOfferType,
    getMaxResidualizedMsrpOverride,
    getMaxResidualizedMsrpAppliedOverrideByOfferType,
    getMaxResidualizedMsrpAppliedOverride,
    getSelectedCapCostReduction,
    getSelectedConditionalIncentivesToDisplay,
    getSelectedConditionalTotal,
    getSelectedCreditTierIdByType,
    getSelectedCreditTierScore,
    getConditionalIncentiveFromTerm,
    getNonConditionalIncentiveFromTerm,
    getGridAspIsUserProgramQuotes,
    getIncentiveById,
    getIncentives,
    getAppliedIncentivesTotalForDisplay,
    getSelectedIncentivesByOfferType,
    hasPaymentGridColumnMessage,
    hasRecordedNonConditionalSelection,
    hasRecordedConditionalSelection,
    getSelectedNonConditionalIncentivesToDisplay,
    getSelectedPaymentGridCellSource,
    isSelectedPaymentGridCellSourcePending,
    getSelectedPaymentProfitDetails,
    getReservePaid,
    getReserveSplitOverride,
    getIsReserveSplitClearedByLenderChange,
    getReserveSplitClearedFrom,
    getReserveFromInterestParticipation,
    getTotalInterestOnRateMarkup,
    getSelectedTerm,
    getSelectedTermAmountFinanced,
    getSelectedTermBaseMonthlyPaymentsTotal,
    getSelectedTermByOfferType,
    getSelectedTermMonths,
    getSelectedTermTotalInterest,
    getSellRate,
    getSellRateOverride,
    getSellRateOverrideByOfferTypeAndTerm,
    getSessionId,
    getShopperCommonConsumerId,
    getShopperInfo,
    getShopperZip,
    getIsShopperInfoMissed,
    getShortDisclaimerData,
    getSliceData,
    getSpecialPaymentFormula,
    getStandardAllowedMiles,
    getTaxBreakdown,
    getTaxesAndFeesTotal,
    getTaxItemsWithAdjustedRates,
    getTaxItemsWithOverrides,
    getTaxItemsWithOverridesWithoutFlat,
    getTaxOverrideUpfront,
    getTerm,
    getTermId,
    getTermIdByOfferType,
    getTermIdForOfferType,
    getTermLength,
    getTerms,
    getTermsByIdForOffer,
    getThresholdMiles,
    getTitlingLenderWithAddress,
    getTotalAccessoriesResidual,
    getTotalAddOns,
    getTotalAmountDue,
    getTotalDepreciation,
    getTotalExcessMilesPurchased,
    getTotalFee,
    getTotalInterest,
    getTotalLenderFees,
    getTotalMiles,
    getTotalOfBasePayments,
    getTotalOfPaymentsAndConsideration,
    getTotalTax,
    getTotalTaxesAndFees,
    getTotalTaxReduction,
    getTradeInItems,
    getTotalUnifiFees,
    getTraceId,
    getTradeInAmountOwed,
    getTradeInValue,
    getTransferRegistrationDetails,
    getPriorLeaseBalance,
    getPriorLeaseBalanceForPayment,
    hasPriorLeaseBalance,
    getUpfrontPriorLeaseBalanceByOfferType,
    getCapitalizedPriorLeaseBalanceByOfferType,
    getUpfrontAddonsTotal,
    getUpfrontFeesTotal,
    getUpfrontTaxTotal,
    getVehicleDetails,
    getVehicleFulfillmentRaw,
    getVehicleSalePrice,
    getYourPriceValue,
    hasCoBuyer,
    hasDealBeenAccepted,
    hasManualTaxItems,
    hasManualTotalTax,
    hasMissingPaymentData,
    isCalculatingPayment,
    isCapCostReductionManual,
    isFlexBuyPayment,
    isFordFlexBuyDeal,
    isFordFlexBuyPayment,
    isMonthlyPaymentInvalid,
    isOfferFromVinSource,
    isOnePayLease,
    isAspPaymentGridRedesignActive,
    isExplicitLenderProgramGridActive,
    isPaymentGridResolving,
    isSelectedTermRecordMissing,
    isTaxCapped,
    isTaxResetDisabled,
    leaseRecordKey,
    getOfferPaymentFrequency,
    recalculateCashAmount,
    shouldGatePaymentGridForQuote,
    shouldIncludeTradeIn,
    getDeferredDownPayment
} = selectors;
